import { PROFILE_TYPES, USER_CODE_STATUS } from '@/utils/enums';
import { format } from 'date-fns';

export const state = {
    userCodes: null,
};

export const getters = {
    userIsAffiliate(state) {
        return state.userCodes?.affiliate?.status === USER_CODE_STATUS.ACTIVE;
    },

    userIsSpecialist(state) {
        return state.userCodes?.specialist?.status === USER_CODE_STATUS.ACTIVE;
    },

    userIsDeveloper(state) {
        return state.userCodes?.developer?.status === USER_CODE_STATUS.ACTIVE;
    },

    /**
     * Deprecated
     * @param {} state
     * @returns
     */
    userRef(state) {
        return state.userCodes?.affiliate.partner_code ?? state.userCodes.specialist.partner_code;
    },

    /**
     * To be deprecated
     * @param {} state
     * @returns user_profile
     */
    userRoleType(state) {
        return state.userCodes?.affiliate.user_profile ?? state.userCodes.specialist.user_profile;
    },

    userRoles(state) {
        if (!state.userCodes) return [];

        return Object.entries(state.userCodes)
            .filter(([_, profile]) => profile.status === USER_CODE_STATUS.ACTIVE)
            .map(([key, _]) => key);
    },

    userRolesStatus(state) {
        return Object.values(PROFILE_TYPES).map((val) => {
            const code = state.userCodes[val];
            const defaultStatus = {
                profile: val,
                label: 'Inativo',
                value: USER_CODE_STATUS.INACTIVE,
            };

            if (!code) {
                return defaultStatus;
            }

            const { status, reproved_at } = code;
            let statusItem = { ...defaultStatus, value: status };

            switch (status) {
                case USER_CODE_STATUS.SUSPENDED:
                    return {
                        ...statusItem,
                        label: 'Bloqueado',
                        date: format(new Date(reproved_at), 'dd/MM/yyyy'),
                        message:
                            'Parece que seu usuário foi bloqueado no programa de especialistas por algum motivo. Para mais informações, envie um e-mail para partners@yampi.com.br',
                    };

                case USER_CODE_STATUS.REPROVED:
                    return {
                        ...statusItem,
                        label: 'Recusada',
                        date: format(new Date(reproved_at), 'dd/MM/yyyy'),
                    };

                case USER_CODE_STATUS.ANALYSIS:
                    return {
                        ...statusItem,
                        label: 'Análise',
                    };

                case USER_CODE_STATUS.INACTIVE:
                    return defaultStatus;

                default:
                    return {
                        ...statusItem,
                        label: 'Ativo',
                    };
            }
        });
    },

    getUserRef: (state) => (type) => {
        return state.userCodes[type]?.partner_code;
    },

    isDeveloperQualified: (state) => state.userCodes['developer']?.is_qualified ?? false,
};

export const mutations = {
    ['UPDATE_USER_CODES'](states, ref) {
        states.userCodes = ref;
    },

    ['SET_DEV_PROFILE'](state, userCode) {
        state.userCodes.developer = userCode;
    },
};

export const actions = {
    updateUserCodes({ commit }, userCodes) {
        commit('UPDATE_USER_CODES', userCodes);
    },

    setDeveloperCode({ commit }) {
        const userCode = {
            user_profile: 'developer',
            created_at: '2024-10-23T17:42:10.000000Z',
            deleted_at: null,
            reproved_at: null,
            is_suspended: false,
            status: 'active',
        };

        commit('SET_DEV_PROFILE', userCode);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
